if(!customElements.get('product-accordion')) {
  customElements.define('product-accordion', class ProductAccoridion extends HTMLElement {
    constructor(){
      super();
      this.openButton = this.querySelector('[data-open]');
      this.body = this.querySelector('[data-body]');
      if(!this.openButton && !this.body) return;
      this.toggleAccordion();
    }

    get open() {
      return this.hasAttribute('open');
    }

    toggleAccordion() {
      this.openButton.addEventListener('click', (event)=> {
        event.preventDefault();
        const offsetHeight = this.body.scrollHeight;
        this.toggleAttribute('open');
        this.open ? this.body.style.height = `${offsetHeight}px` : this.body.style.height = `0px`;
      })
    }
  })
}